module.exports = __webpack_public_path__ + "static/media/activity.a35d9fcd.jpg";